import { useAuth0 } from '@auth0/auth0-react'
import { APP_MENU_SELECTED_KEY } from '@constants/storageHelper'
import StorageHelper from '@modules/storage'
import { getCustomClaim, hasPermissions } from '@wdnsolutions/auth-helpers'
import { useCallback, useEffect, useState } from 'react'

import { extractPermissionsFromMetadata } from '../../constants'

export type Permission = string

export const usePermissions = () => {
  const { getIdTokenClaims, logout } = useAuth0()
  const [userPermissions, setUserPermissions] = useState<Permission[]>()

  useEffect(() => {
    let isMounted = true
    ;(async () => {
      if (!isMounted) {
        return
      }

      let claims = await getIdTokenClaims()
      if (!claims) {
        claims = await getIdTokenClaims()
        if (!claims) {
          StorageHelper.setItem(APP_MENU_SELECTED_KEY, null)
          logout({ returnTo: window.location.origin })
        }
      }

      const app_metadata = getCustomClaim(claims, 'app_metadata')
      const permissions = extractPermissionsFromMetadata(app_metadata)
      setUserPermissions(permissions)
    })()

    return () => {
      isMounted = false
    }
  }, [getIdTokenClaims])

  const allowed = useCallback(
    (permissions: Permission[] = []) => {
      if (!userPermissions) return false
      if (permissions.length === 0) return true
      return hasPermissions(permissions, userPermissions)
    },
    [userPermissions],
  )

  return {
    allowed,
    /** False until the user's permissions have been read from the ID token. */
    loaded: Boolean(userPermissions),
  }
}
